import React from 'react';
import StatusBadge from '../../../components/ui/StatusBadge';
import {
  IMPORT_FILE_STATUS_SHORT_LABELS,
  getStatusIcon,
  statusShouldSpin,
} from '../../../support/iconMappings';
import { IMPORT_FILE_STATUS_LABELS, IMPORT_FILE_STATUS_STYLES } from '../constants';

function ImportFileStatusBadge({ status, compact = false }) {
  const fullLabel = IMPORT_FILE_STATUS_LABELS[status] || status;
  const shortLabel = IMPORT_FILE_STATUS_SHORT_LABELS[status] || fullLabel;
  const style = IMPORT_FILE_STATUS_STYLES[status] || 'bg-slate-100 text-slate-600 border-slate-200';
  const Icon = getStatusIcon('importFile', status);

  return (
    <StatusBadge
      label={shortLabel}
      title={fullLabel}
      styleClass={style}
      icon={Icon}
      compact={compact}
      spin={statusShouldSpin('importFile', status)}
    />
  );
}

export default ImportFileStatusBadge;
